import { render, staticRenderFns } from "./RecFilesTable.vue?vue&type=template&id=ee7ac6f4&"
import script from "./RecFilesTable.vue?vue&type=script&lang=js&"
export * from "./RecFilesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports